var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInrlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.7334C7 18.6354 7.73127 19.3667 8.63333 19.3667C9.5354 19.3667 10.2667 18.6354 10.2667 17.7334C10.2667 17.5922 10.2432 17.4577 10.2095 17.327L12.3342 13.608L16.0542 15.7338C16.2509 16.4153 16.872 16.9167 17.6167 16.9167C18.5187 16.9167 19.25 16.1854 19.25 15.2834C19.25 15.1351 19.2239 14.9942 19.1869 14.8575L22.1689 9.49018C22.8408 9.28765 23.3333 8.6713 23.3333 7.93338C23.3333 7.03132 22.6021 6.30005 21.7 6.30005C20.7979 6.30005 20.0667 7.03132 20.0667 7.93338C20.0667 8.08108 20.0926 8.22155 20.1293 8.35758L17.1696 13.6845L13.4623 11.5656C13.2656 10.8845 12.6445 10.3834 11.9 10.3834C10.9979 10.3834 10.2667 11.1146 10.2667 12.0167C10.2667 12.1581 10.2904 12.293 10.3241 12.4238L8.18323 16.1707C7.50167 16.3672 7 16.9886 7 17.7334Z",
    fill: "#573E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 21.0001H4.66634V5.83341C4.66634 5.1886 4.14449 4.66675 3.49967 4.66675C2.85486 4.66675 2.33301 5.1886 2.33301 5.83341V22.1667C2.33301 22.8116 2.85486 23.3334 3.49967 23.3334H24.4997C25.1445 23.3334 25.6663 22.8116 25.6663 22.1667C25.6663 21.5219 25.1445 21.0001 24.4997 21.0001Z",
    fill: "#573E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInrlogo);
export default __webpack_public_path__ + "static/media/inrlogo.3af107aba54db0fa068c5e2ed09cf0dc.svg";
export { ForwardRef as ReactComponent };